/**
 * Created by mac on 9/25/20
 */

const AdminEpisodes = function (administrator) {
    this.administrator = administrator;

    cleverapps.EventEmitter.call(this);

    this.onUpdateHoverEpisodeListener = function () {};
    this.onUpdateEpisodeListener = function () {};
};

AdminEpisodes.prototype = Object.create(cleverapps.EventEmitter.prototype);
AdminEpisodes.prototype.constructor = AdminEpisodes;

AdminEpisodes.prototype.updateDebugs = function () {
    let inherits = false;
    let lastNumber = -1;

    this.episodes.forEach((episode) => {
        if (episode.isAddMoreEpisode()) {
            return;
        }

        const isNumber = cleverapps.isNumber(episode.episodeNo) && parseInt(episode.episodeNo) >= 0;
        const bundle = episode.getBundle();
        if (!bundle) {
            return;
        }

        let approved = true;
        const episodeType = Level.CalcLevelType(episode.episodeNo);

        if (cleverapps.config.type === "merge") {
            episode.setApproved(approved);
            return;
        }

        if (isNumber && inherits) {
            approved = false;
        }

        if (isNumber && lastNumber < (parseInt(episode.episodeNo) - 1)) {
            approved = false;
        }

        if (bundle.meta.episode.levelsAmount < AdminEpisode.LEVELS_PER_EPISODE && episodeType !== Level.LevelTypes.HIGHSCORE_MODE) {
            approved = false;
        }

        if (!isNumber && episodeType !== Level.LevelTypes.BONUS_WORLD && episodeType !== Level.LevelTypes.HIGHSCORE_MODE) {
            approved = false;
        }

        if (isNumber) {
            lastNumber = parseInt(episode.episodeNo);
        }

        episode.setApproved(approved);

        if (isNumber && (!approved || episode.isDebug())) {
            inherits = true;
        }
    });

    this.trigger("updateApproved");
};

AdminEpisodes.prototype.next = function (sign) {
    const pos = this.episodes.indexOf(this.active) + sign;

    if (this.episodes[pos] === undefined || this.episodes[pos].isAddMoreEpisode()) {
        return undefined;
    }

    return this.episodes[pos];
};

AdminEpisodes.prototype.updateIndexes = function () {
    this.episodes.forEach((episode, index) => {
        if (episode.index !== undefined) {
            episode.index = index;
        }
    });
};

AdminEpisodes.prototype.getInsertionIndex = function (episodeNo) {
    let index = 0;
    while (index < this.total) {
        const prevEpisodeNo = this.episodes[index].episodeNo;
        if (AdminEpisodes.EPISODE_NUMBERS_COMPARATOR(prevEpisodeNo, episodeNo) >= 0) {
            break;
        }
        index++;
    }
    return index;
};

AdminEpisodes.prototype.insertToArray = function (episodeNo) {
    const index = this.getInsertionIndex(episodeNo);

    const episode = AdminEpisode.create(index, episodeNo);
    this.episodes.splice(index, 0, episode);
    this.episodesByName[episodeNo] = episode;
    this.total = this.episodes.length - 1;

    this.updateIndexes();
    this.updateDebugs();

    this.trigger("insert", episode);
};

AdminEpisodes.prototype.removeFromArray = function (episodeNo) {
    const episode = this.episodesByName[episodeNo];
    const index = episode.index;
    this.episodes.splice(index, 1);
    episode.purge();
    this.total = this.episodes.length - 1;
    delete this.episodesByName[episodeNo];

    this.updateIndexes();
    this.updateDebugs();

    this.trigger("remove", episode);
};

AdminEpisodes.prototype.renameInArray = function (oldEpisodeNo, newEpisodeNo) {
    const episode = this.episodesByName[oldEpisodeNo];
    const index = episode.index;
    this.episodes.splice(index, 1);
    delete this.episodesByName[oldEpisodeNo];
    this.total = this.episodes.length - 1;

    const newIndex = this.getInsertionIndex(newEpisodeNo);

    episode.setEpisodeNo(newEpisodeNo);
    episode.index = newIndex;
    this.episodes.splice(newIndex, 0, episode);
    this.episodesByName[newEpisodeNo] = episode;
    this.total = this.episodes.length - 1;

    this.updateIndexes();
    this.updateDebugs();
    this.trigger("rename", episode, oldEpisodeNo);
};

AdminEpisodes.prototype.createNew = function (callback) {
    const numbers = this.episodes.filter((episode) => episode.isNumeric()).map((episode) => episode.episodeNo);
    const episodeNo = numbers.length ? Math.max(...numbers) + 1 : 0;
    const data = {
        debug: true,
        levels: []
    };

    this.saveToStorage(episodeNo, data);
    this.insertToArray(episodeNo);
    this.setActive(this.episodesByName[episodeNo], callback);
};

AdminEpisodes.prototype.remove = function (episodeNo, callback) {
    const language = this.getEpisodesLanguage();
    const episode = this.episodesByName[episodeNo];

    cleverapps.git.remove("episode", {
        episodeNo,
        language
    });

    this.onUpdateEpisodeListener(episodeNo);
    this.administrator.simpleMethaDataProvider && this.administrator.simpleMethaDataProvider.reset();
    this.removeFromArray(episodeNo);

    const prevEpisode = this.episodes[Math.max(0, episode.index - 1)];
    if (prevEpisode && !prevEpisode.isAddMoreEpisode()) {
        this.setActive(prevEpisode, callback);
    } else {
        callback();
    }
};

AdminEpisodes.prototype.copy = function (episodeNo, callback) {
    const language = this.getEpisodesLanguage();

    let copyEpisodeNo = `${String(episodeNo).replace(/_copy(_\d+)?/, "")}_copy`;
    let copyBundleName = AdminEpisode.BundleId(copyEpisodeNo, language);

    for (let i = 1; bundles[copyBundleName]; ++i) {
        copyEpisodeNo = `${String(episodeNo).replace(/_copy(_\d+)?/, "")}_copy_${i}`;
        copyBundleName = AdminEpisode.BundleId(copyEpisodeNo, language);
    }

    const bundleName = AdminEpisode.BundleId(episodeNo, language);
    const bundle = bundles[bundleName];

    cleverapps.bundleLoader.loadBundle(bundleName, {
        onSuccess: function () {
            let content = JSON.parse(JSON.stringify(cc.loader.getRes(bundle.jsons.levels)));

            if (!content.levels) {
                content = { levels: content };
            }

            content.debug = true;

            this.saveToStorage(copyEpisodeNo, content);
            this.insertToArray(copyEpisodeNo);
            this.setActive(this.episodesByName[copyEpisodeNo], callback);

            cleverapps.bundleLoader.deleteBundle(bundleName);
        }.bind(this),

        onError: function () {
            cleverapps.notification.create("Copy episode error");
            callback();
        }
    });
};

AdminEpisodes.prototype.rename = function (episodeNo, newEpisodeNo, callback) {
    const language = this.getEpisodesLanguage();
    const bundleName = AdminEpisode.BundleId(episodeNo, language);
    const bundle = bundles[bundleName];

    cleverapps.bundleLoader.loadBundle(bundleName, {
        onSuccess: function () {
            const content = JSON.parse(JSON.stringify(cc.loader.getRes(bundle.jsons.levels)));

            cleverapps.git.remove("episode", {
                episodeNo,
                language
            });

            this.saveToStorage(newEpisodeNo, content);
            this.renameInArray(episodeNo, newEpisodeNo);
            cleverapps.administrator.adminLevels.reset(callback);

            cleverapps.bundleLoader.deleteBundle(bundleName);
        }.bind(this),

        onError: function () {
            cleverapps.notification.create("Rename episode error");
            callback();
        }
    });
};

AdminEpisodes.prototype.upload = function (levels, callback) {
    const episode = this.getActive();
    const episodeNo = episode.episodeNo;
    const language = cleverapps.config.type === "board" ? cleverapps.settings.language : undefined;

    try {
        levels = JSON.parse(levels);
    } catch (e) {
        cleverapps.notification.create("Error parse episode content");
    }

    const bundleName = AdminEpisode.BundleId(episodeNo, language);
    const bundle = bundles[bundleName];

    cleverapps.bundleLoader.loadBundle(bundleName, {
        onSuccess: function () {
            let content = cc.loader.getRes(bundle.jsons.levels);
            if (!content.levels) {
                content = { levels: content };
            }

            content.levels = content.levels.concat(levels);

            content.levels.forEach((level, levelNo) => {
                if (!Array.isArray(level)) {
                    level = [level];
                }

                level.forEach((levelVersion) => {
                    levelVersion.episodeNo = episodeNo;
                    levelVersion.levelNo = levelNo;
                });
            });

            cleverapps.git.edit("episode", {
                episodeNo,
                language,
                content
            });

            this.saveToStorage(episodeNo, content);

            cleverapps.administrator.adminLevels.reset(callback);

            cleverapps.bundleLoader.deleteBundle(bundleName);
        }.bind(this),

        onError: function () {
            cleverapps.notification.create("Upload episode error");
            callback();
        }
    });
};

AdminEpisodes.prototype.setDebug = function (debug, callback) {
    const episode = this.getActive();
    const episodeNo = episode.episodeNo;
    const language = cleverapps.config.type === "board" ? cleverapps.settings.language : undefined;

    const bundleName = AdminEpisode.BundleId(episodeNo, language);
    const bundle = bundles[bundleName];

    cleverapps.bundleLoader.loadBundle(bundleName, {
        onSuccess: function () {
            let content = cc.loader.getRes(bundle.jsons.levels);
            if (!content.levels) {
                content = { levels: content };
            }

            content.levels.forEach((level, levelNo) => {
                if (!Array.isArray(level)) {
                    level = [level];
                }

                level.forEach((levelVersion) => {
                    levelVersion.episodeNo = episodeNo;
                    levelVersion.levelNo = levelNo;
                });
            });

            content.debug = debug;

            cleverapps.git.edit("episode", {
                episodeNo,
                language,
                content
            });

            this.saveToStorage(episodeNo, content);

            cleverapps.bundleLoader.deleteBundle(bundleName);

            callback();
        }.bind(this),

        onError: function () {
            cleverapps.notification.create("Upload episode error");
            callback();
        }
    });
};

AdminEpisodes.prototype.getActive = function () {
    return this.active;
};

AdminEpisodes.prototype.setActive = function (episode, f, suggestedLevel) {
    if (this.active === episode) {
        f && f();
        return;
    }

    if (this.active !== undefined) {
        this.active.unselect();
    }

    this.active = episode;
    this.active.select();

    if (cleverapps.config.adminMode) {
        cleverapps.setUrlHash({ episode: this.active.episodeNo });
    }

    cleverapps.administrator.adminLevels.reset(f, suggestedLevel);
    cleverapps.administrator.log.onChangeEpisode(episode);

    this.trigger("setActive", episode);
};

AdminEpisodes.prototype.hover = function (episode) {
    if (this.hoverEpisode !== episode) {
        this.hoverEpisode = episode;
        this.onUpdateHoverEpisodeListener();
    }
};

AdminEpisodes.prototype.unhover = function (episode) {
    if (this.hoverEpisode === episode) {
        delete this.hoverEpisode;
        this.onUpdateHoverEpisodeListener();
    }
};

AdminEpisodes.prototype.reset = function (f) {
    delete this.hoverEpisode;

    const names = AdminEpisodes.GetEpisodeNames(cleverapps.settings.language);

    const episodes = [];
    const episodesByName = {};
    let prodEpisodesLength = -1;

    for (let i = 0; i < names.length; i++) {
        const name = names[i];
        const episode = AdminEpisode.create(i, name);
        prodEpisodesLength += episode.isNumeric();
        episodes.push(episode);
        episodesByName[name] = episode;
    }

    this.total = episodes.length;

    const addMoreEpisode = AdminEpisode.createAddMoreEpisode();
    episodesByName[addMoreEpisode.episodeNo] = addMoreEpisode;
    episodes.push(addMoreEpisode);

    this.episodes = episodes;
    this.episodesByName = episodesByName;

    this.updateDebugs();
    this.trigger("reset");

    const params = cleverapps.getRequestParameters(window.location.hash);
    const episodeNo = params.episode > prodEpisodesLength ? prodEpisodesLength : params.episode;
    const levelNo = params.level !== undefined && (AdminEpisode.LEVELS_PER_EPISODE >= params.level) ? params.level : cleverapps.user.currentPhysicalLevel.level;

    if (!cleverapps.config.adminMode && cleverapps.user.isPassedAllPhysicalLevels()) {
        f();
        return;
    }

    const activeEpisode = this.episodesByName[episodeNo] || this.episodesByName[cleverapps.user.currentPhysicalLevel.episode];
    if (activeEpisode) {
        this.setActive(activeEpisode, f, levelNo);
    } else {
        f();
    }
};

AdminEpisodes.prototype.getEpisode = function (episodeNo) {
    return this.episodesByName[episodeNo];
};

AdminEpisodes.prototype.update = function () {
    this.episodes.forEach((episode) => {
        episode.onUpdate();
    });
};

AdminEpisodes.prototype.updateCurrent = function () {
    this.episodes.forEach((episode) => {
        episode.onUpdateCurrent();
    });
};

AdminEpisodes.GetEpisodeNames = function (language) {
    let episodeBundles = Object.values(bundles).filter((bundle) => bundle.meta.episode && bundle.meta.episode.episodeNo !== "coming_soon");

    if (cleverapps.config.type === "board") {
        episodeBundles = episodeBundles.filter((bundle) => bundle.meta.episode.language === language);
    }

    let episodeNumbers = episodeBundles.map((bundle) => bundle.meta.episode.episodeNo);

    episodeNumbers = episodeNumbers.sort(AdminEpisodes.EPISODE_NUMBERS_COMPARATOR);

    return episodeNumbers;
};

AdminEpisodes.prototype.saveToStorage = function (episodeNo, data) {
    const language = this.getEpisodesLanguage();

    cleverapps.git.edit("episode", {
        episodeNo,
        language,
        content: data
    });

    this.updateDebugs();
    this.onUpdateEpisodeListener(episodeNo);
    if (this.episodesByName[episodeNo]) {
        this.episodesByName[episodeNo].onUpdate();
    }

    this.administrator.simpleMethaDataProvider && this.administrator.simpleMethaDataProvider.reset();
};

AdminEpisodes.prototype.scrollToEp = function (episodeNo) {
    this.trigger("scrollToEp", episodeNo);
};

AdminEpisodes.prototype.getEpisodesLanguage = function () {
    return cleverapps.config.type === "board" ? cleverapps.settings.language : undefined;
};

AdminEpisodes.ResetAction = function (f) {
    cleverapps.administrator.adminEpisodes.reset(f);
};

AdminEpisodes.EPISODE_NUMBERS_COMPARATOR = (number1, number2) => {
    if (Number.isNaN(number1)) {
        return -1;
    }

    if (Number.isNaN(number2)) {
        return 1;
    }

    return (parseInt(number1) - parseInt(number2)) || (`${number1}`).localeCompare(`${number2}`);
};
